import { AbstractModel } from '../shared/abstract.model';

export class Linking extends AbstractModel {
  sourceId: string;
  regoId: string;
  sourceSystem: string;
  sourceSystemNode?: string;
  sourceLinkType?: string;
}
